module.exports = __webpack_public_path__ + "media/components/signup/static/surf-forecast_outside--header_logo-19c9a9f7108a93feaed677d97d9ec282.webp";